export default "__VITE_ASSET__CYqe78_5__"